export enum PhxDataTableShowCheckboxesMode {
  None = 'none',
  OnClick = 'onClick',
  OnLongTap = 'onLongTap',
  Always = 'always',
}
